import { createUseStyles } from 'react-jss'
import { trafficRedDark } from '../../styles/const/colors'

const useStyles = createUseStyles({
  inviteButtonsWrapper: {
    textAlign: 'center',
    paddingTop: 8
  },
  button: {
    marginTop: 24,
    marginBottom: 20,
    width: '100%',
    maxWidth: 280
  },
  decline: {
    color: trafficRedDark,
    '&:hover': {
      cursor: 'pointer'
    }
  }
})

export default useStyles
